<sdps-modal-beta #createRuleModal sdps-title="Create Custom Rule" class="create-rule-modal" id="create-rule-modal"
    (closeButtonClick)="onCancelClick()">
    <div slot="modal-body">
        <mm-banners *ngIf="showErrorBanner" class="errorBanner" [bannerText]="[bannerErrorText]" [type]="'error'"
            data-testid="custom-rule-modal-error"></mm-banners>
        <mm-banners *ngIf="errorOnCreateRule" class="errorBanner" [bannerText]="[createRuleConstants.callToCustomRulePostFailedText + selectedRuleName]" [type]="'error'"
            data-testid="custom-rule-modal-server-error"></mm-banners>
        <div class="modal-text">
            <p>{{this.createRuleConstants.modalDisclaimerText}}</p>
        </div>
        <div class="modal-input-section">
            <mm-text-input-control class="ruleText" [parentForm]="createRuleModalFormGroup"
                [inputControlModel]="ruleNameModel" [useDirty]="true"></mm-text-input-control>
            <mm-radio-control class="ruleType" [parentForm]="createRuleModalFormGroup"
                [radioModel]="ruleTypeSelectorModel" data-testid="ruleTypeSelectorModelid"> </mm-radio-control>
            <mm-text-input-control *ngIf="isTransactionRuleType" class="ruleAmount"
                [parentForm]="createRuleModalFormGroup" (keydown)="validateOnKeyDown($event)" (blur)="formatAmount()"
                [inputControlModel]="ruleAmountModel" [useDirty]="true"></mm-text-input-control>
        </div>
        <div>
            <div>
                <p class="modalDisclaimerTextClass"
                    [ngClass]="{'errorTitle': transactionTypeHasError || partyHasError || authorizationHasError}">
                    Select at least one of the following:
                </p>
            </div>
            <div class="createRuleCheckboxSection">
                <div class="checkboxSection" *ngIf="isTransactionRuleType">
                    <div>
                        <p [ngClass]="{'errorTitle': transactionTypeHasError}">Transaction type</p>
                    </div>

                    <div class="checkboxContainer">
                        <div>
                            <input class="checkbox" type="checkbox" [formControl]="createRuleAllTransactionType"
                                id="typeCheckAll">
                            <label class="checkboxLabel" for="typeCheckAll">All</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleAch" id="typeCheckAch">
                            <label class="checkboxLabel" for="typeCheckAch">ACH (MoneyLink)</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleCheck" id="typeCheckCheck">
                            <label class="checkboxLabel" for="typeCheckCheck">Check</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleIt" id="typeCheckIt">
                            <label class="checkboxLabel" for="typeCheckIt">Internal transfer (journal)</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleWire" id="typeCheckWire">
                            <label class="checkboxLabel" for="typeCheckWire">Wire</label>
                        </div>
                    </div>
                </div>

                <div class="checkboxSection" *ngIf="isTransactionRuleType || isStandingAuthorizationRuleType">
                    <div>
                        <p [ngClass]="{'errorTitle': partyHasError}">Party</p>
                    </div>

                    <div class="checkboxContainer">
                        <div>
                            <input class="checkbox" type="checkbox" [formControl]="createRuleAllParty"
                                id="typeCheckAllParty">
                            <label class="checkboxLabel" for="typeCheckAllParty">All</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleFirstParty"
                                id="firstParty">
                            <label class="checkboxLabel" for="firstParty">1st Party</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleThirdParty"
                                id="thirdParty">
                            <label class="checkboxLabel" for="thirdParty">3rd Party</label>
                        </div>
                    </div>
                </div>

                <div class="checkboxSection" *ngIf="isTransactionRuleType">
                    <div>
                        <p [ngClass]="{'errorTitle': authorizationHasError}">Authorization</p>
                    </div>

                    <div class="checkboxContainer">
                        <div>
                            <input class="checkbox" type="checkbox" [formControl]="createRuleAllAuth"
                                id="typeCheckAllAuth">
                            <label class="checkboxLabel" for="typeCheckAllAuth">All</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleNoAuthRequired"
                                id="noAuthRequired">
                            <label class="checkboxLabel" for="noAuthRequired">No client authorization required</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleOneTimeAuthRequired"
                                id="oneTimeAuth">
                            <label class="checkboxLabel" for="oneTimeAuth">One-time client authorization</label>
                        </div>
                        <div class="tabCheckBoxes">
                            <input class="checkbox" type="checkbox" [formControl]="createRuleStandingAuth"
                                id="standingAuth">
                            <label class="checkboxLabel" for="standingAuth">Standing authorization</label>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div slot="modal-footer">
        <button (click)="onCancelClick()" type="button" id="create-rule-modal-cancel"
            class="sdps-button sdps-button--small sdps-button--secondary">Cancel</button>
        <button (click)="onModalCreateRuleClick()" type="button" id="create-rule-modal-submit"
            class="sdps-button sdps-button--primary sdps-button--small">Create Rule</button>
    </div>
</sdps-modal-beta>